
export default {
  name: 'BbAvatar',
  props: {
    avatarSrc: String,
    color: String,
    fullName: String,
    height: [Number, String],
    maxHeight: [Number, String],
    maxWidth: [Number, String],
    minHeight: [Number, String],
    minWidth: [Number, String],
    radius: {
      type: [Number, String],
      default: 50,
    },
    size: {
      type: [Number, String],
      default: 40,
    },
    text: String,
    width: [Number, String],
  },
  computed: {
    computedProps() {
      return {
        color: this.color,
        height: this.height,
        maxHeight: this.maxHeight,
        maxWidth: this.maxWidth,
        minHeight: this.minHeight,
        minWidth: this.minWidth,
        size: this.size,
        width: this.width,
      };
    },
    handledBorderRadius() {
      return typeof this.radius === 'number' ? `${this.radius}%` : this.radius;
    },
    displayText() {
      return (
        this.text
        || this.fullName
          ?.split(' ')
          .map((item) => item[0])
          .join('')
          .toUpperCase()
        || ''
      );
    },
    avatarPath() {
      return `url('${this.avatarSrc}')`;
    },
  },
};
